export const GET_WORKORDER_REQUEST = "GET_WORKORDER_REQUEST";
export const GET_WORKORDER_SUCCESS = "GET_WORKORDER_SUCCESS";
export const GET_WORKORDER_FAILURE = "GET_WORKORDER_FAILURE";

export const GET_ITEMSFORWORKORDER_REQUEST = "GET_ITEMSFORWORKORDER_REQUEST";
export const GET_ITEMSFORWORKORDER_SUCCESS = "GET_ITEMSFORWORKORDER_SUCCESS";
export const GET_ITEMSFORWORKORDER_FAILURE = "GET_ITEMSFORWORKORDER_FAILURE";
